// import React, { useState, useEffect, useMemo } from 'react';
// import { useSelector } from 'react-redux';
// import Sidebar from '../Core/Sidebar';
// import Navbar from '../Core/Navbar';
// import { Search, Filter, Download, Calendar, ArrowUpRight, CreditCard } from 'lucide-react';
// import * as XLSX from 'xlsx';
// import { toast } from 'react-toastify';
// import '../../Dashboard Style/WalletTransaction.css'; // Reusing your existing CSS

// const LowestIncome = ({ title, incomeType }) => {
//   const authToken = useSelector((state) => state.user?.token);
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [perPage, setPerPage] = useState(15);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [dateFilter, setDateFilter] = useState('all');
//   const [originalTransactions, setOriginalTransactions] = useState([]);
  

//   const toggleSidebar = () => {
//       setSidebarOpen(!sidebarOpen);
//     };
  
//     // Initialize sidebar functionality (same as in Dashboard)
//     useEffect(() => {
//       const sidebar = document.querySelector('.sidebar');
//       const sidebarBody = document.querySelector('.sidebar-body');
      
//       if (sidebar) {
//         if (sidebarOpen) {
//           sidebar.classList.remove('close');
//         } else {
//           sidebar.classList.add('close');
//         }
//       }
      
//       // Add custom scrollbar to sidebar body
//       if (sidebarBody) {
//         sidebarBody.style.height = 'calc(100vh - 70px)';
//         sidebarBody.style.overflowY = 'auto';
//       }
  
//       return () => {
//         // Cleanup
//       };
//     }, [sidebarOpen]);
  
//     useEffect(() => {
//       // Add custom scrollbar styles for sidebar
//       const style = document.createElement('style');
//       style.innerHTML = `
//         /* Custom scrollbar for sidebar */
//         .sidebar-body {
//           height: calc(100vh - 70px);
//           overflow-y: auto;
//         }
        
//         .sidebar-body::-webkit-scrollbar {
//           width: 6px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-track {
//           background: rgba(255, 255, 255, 0.05);
//           border-radius: 10px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-thumb {
//           background: rgba(255, 255, 255, 0.2);
//           border-radius: 10px;
//         }
        
//         .sidebar-body::-webkit-scrollbar-thumb:hover {
//           background: rgba(255, 255, 255, 0.3);
//         }
        
//         /* Sidebar dropdown menu styles */
//         .sidebar .nav-dropdown {
//           list-style: none;
//           padding-left: 0;
//           max-height: 0;
//           overflow: hidden;
//           transition: max-height 0.3s ease;
//         }
        
//         .sidebar .nav-dropdown.show {
//           max-height: 500px;
//         }
        
//         .sidebar .nav-dropdown-item {
//           padding-left: 2.5rem;
//         }
        
//         /* Sidebar dropdown toggle with icon */
//         .nav-item.has-dropdown .nav-link {
//           position: relative;
//           padding-right: 2.5rem;
//         }
        
//         .nav-item.has-dropdown .dropdown-icon {
//           position: absolute;
//           right: 1rem;
//           top: 50%;
//           transform: translateY(-50%);
//           transition: transform 0.3s ease;
//         }
        
//         .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//           transform: translateY(-50%) rotate(180deg);
//         }
        
//         /* Improved dropdown styling similar to first image */
//         .nav-item.has-dropdown .nav-dropdown {
//           background: rgba(255, 255, 255, 0.05);
//           border-left: 3px solid var(--primary-color, #0d6efd);
//           margin-left: 1rem;
//           border-radius: 0 0 8px 8px;
//         }
        
//         .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//           padding: 0.75rem 1rem 0.75rem 2rem;
//           color: rgba(255, 255, 255, 0.8);
//         }
        
//         .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//           background: rgba(255, 255, 255, 0.1);
//           color: white;
//         }
        
//         /* Fix for category text styling */
//         .nav-item.has-dropdown .link-title.nav-item.nav-category {
//           font-weight: 600;
//           font-size: 0.875rem;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }
        
//         /* Smooth transitions */
//         .sidebar {
//           transition: all 0.3s ease;
//         }
//       `;
//       document.head.appendChild(style);
  
//       return () => {
//         document.head.removeChild(style);
//       };
//     }, []);

//   const fetchIncomeData = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`https://global.thewillowquantum.com/api/user/get-wallet-transaction`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         body: new URLSearchParams({
//           wallet_type: incomeType, // Dynamic based on route
//           per_page: perPage.toString(),
//           page: currentPage.toString()
//         })
//       });

//       const data = await response.json();
//       if (data.status) {
//         setTransactions(data.data || []);
//         setTotalPages(data.pagination?.last_page || 1);
//       } else {
//         toast.error(data.message || `Failed to fetch ${title}`);
//       }
//     } catch (error) {
//       toast.error("Connection Error");
//     } finally {
//       setLoading(false);
//     }
//   };

//     const handleDateFilterChange = (filter) => {
//       setDateFilter(filter);
//       setCurrentPage(1);
//       toast.info(`Date filter changed to ${filter === 'all' ? 'All Time' : filter}`);
//     };

//       const handleSearch = (e) => {
//     e.preventDefault();
//     // Search is handled by filteredTransactions memo
//   };

//    const filteredTransactions = useMemo(() => {
//       let filtered = [...originalTransactions];
  
//       // Apply search filter
//       if (searchQuery.trim()) {
//         const query = searchQuery.toLowerCase();
//         filtered = filtered.filter(transaction => 
//           transaction.transaction_id?.toString().toLowerCase().includes(query) ||
//           transaction.from_user_email?.toLowerCase().includes(query) ||
//           transaction.transaction_type?.toLowerCase().includes(query) ||
//           transaction.opening_bal?.toString().includes(query) ||
//           transaction.credit_bal?.toString().includes(query) ||
//           transaction.debit_bal?.toString().includes(query) ||
//           transaction.closing_bal?.toString().includes(query)
//         );
//       }
  
//       // Apply date filter
//       if (dateFilter !== 'all') {
//         const now = new Date();
//         filtered = filtered.filter(transaction => {
//           const transactionDate = new Date(transaction.created_at);
          
//           switch (dateFilter) {
//             case 'today':
//               return transactionDate.toDateString() === now.toDateString();
            
//             case 'week': {
//               const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
//               return transactionDate >= oneWeekAgo;
//             }
            
//             case 'month': {
//               const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
//               return transactionDate >= oneMonthAgo;
//             }
            
//             case 'year': {
//               const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
//               return transactionDate >= oneYearAgo;
//             }
            
//             default:
//               return true;
//           }
//         });
//       }
  
//       return filtered;
//     }, [originalTransactions, searchQuery, dateFilter]);
  

//   useEffect(() => { fetchIncomeData(); }, [currentPage, perPage, incomeType]);

//   const filteredData = useMemo(() => {
//     let filtered = [...transactions];
//     if (searchQuery.trim()) {
//       const q = searchQuery.toLowerCase();
//       filtered = filtered.filter(t => t.transaction_id?.toString().includes(q) || t.from_user_email?.toLowerCase().includes(q));
//     }
//     return filtered;
//   }, [transactions, searchQuery]);

//   const handleDownload = () => {
//     const ws = XLSX.utils.json_to_sheet(filteredData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Report');
//     XLSX.writeFile(wb, `${title}_Report.xlsx`);
//     toast.success("Report Exported");
//   };

//   return (
//       <div className="main-wrapper dark-theme">
//       {/* Sidebar */}
//       <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//         <div className="sidebar-header">
//           <a href="#" className="sidebar-brand">
//             <i className="me-2" data-lucide="atom"></i>
//             Willow <span>Quantum</span>
//           </a>
//           <div className="sidebar-toggler" onClick={toggleSidebar}>
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
//         <Sidebar />
//       </nav>

//       <div className="page-wrapper">
//         {/* Navbar - Update to pass toggleSidebar prop */}
//         <Navbar toggleSidebar={toggleSidebar} />
//         <div className="page-content p-4">
//           <div className="d-flex justify-content-between align-items-center mb-4">
//             <h3 className="text-white">{title}</h3>
//           </div>

//          <div className="row mb-4">
//                       <div className="col-md-8">
//                         <div className="d-flex gap-3 search-filter">
//                           <form onSubmit={handleSearch} className="flex-grow-1">
//                             <div className="search-box">
//                               <Search size={18} className="search-icon" />
//                               <input
//                                 type="text"
//                                 className="search-input"
//                                 placeholder="Search by transaction ID, email, or amount..."
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                               />
//                               {/* <button type="submit" className="search-btn">
//                                 Search
//                               </button> */}
//                             </div>
//                           </form>
//                           <div className="dropdown">
//                             <button
//                               className="btn btn-outline-light dropdown-toggle"
//                               type="button"
//                               data-bs-toggle="dropdown"
//                             >
//                               <Filter size={16} className="me-2" />
//                               {dateFilter === 'all' ? 'Filter by Date' : dateFilter.charAt(0).toUpperCase() + dateFilter.slice(1)}
//                             </button>
//                             <div className="dropdown-menu">
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'today' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('today')}
//                               >
//                                 Today
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'week' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('week')}
//                               >
//                                 This Week
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'month' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('month')}
//                               >
//                                 This Month
//                               </button>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'year' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('year')}
//                               >
//                                 This Year
//                               </button>
//                               <div className="dropdown-divider"></div>
//                               <button 
//                                 className={`dropdown-item ${dateFilter === 'all' ? 'active' : ''}`}
//                                 onClick={() => handleDateFilterChange('all')}
//                               >
//                                 All Time
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="col-md-4">
//                         <div className="d-flex export-page gap-2">
//                           <button 
//                             className="btn btn-outline-light"
//                             onClick={handleDownload}
//                             disabled={filteredTransactions.length === 0}
//                           >
//                             <Download size={16} className="me-2" />
//                             Export ({filteredTransactions.length})
//                           </button>
//                           <div className="dropdown">
//                             <button
//                               className="btn btn-outline-light dropdown-toggle"
//                               type="button"
//                               data-bs-toggle="dropdown"
//                             >
//                               {perPage} per page
//                             </button>
//                             <div className="dropdown-menu">
//                               {[10, 15, 25, 50, 100].map((num) => (
//                                 <button
//                                   key={num}
//                                   className={`dropdown-item ${perPage === num ? 'active' : ''}`}
//                                   onClick={() => {
//                                     setPerPage(num);
//                                     toast.info(`Displaying ${num} transactions per page`);
//                                   }}
//                                 >
//                                   {num} per page
//                                 </button>
//                               ))}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//           <div className="transaction-table-wrapper">
//             {loading ? (
//               <div className="text-center py-5"><div className="spinner-border text-light"></div></div>
//             ) : (
//               <div className="table-responsive">
//                 <table className="transaction-table">
//                   <thead>
//                     <tr>
//                       <th>Transaction ID</th>
//                       <th>Type</th>
//                       <th>From/To</th>
//                       <th>Opening</th>
//                       <th>Amount</th>
//                       <th>Closing</th>
//                       <th>Date</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {filteredData.map((t) => (
//                       <tr key={t.id}>
//                         <td>#{t.transaction_id}</td>
//                         <td className="text-info"><CreditCard size={14} className="me-1"/> {t.transaction_type}</td>
//                         <td>{t.from_user_email || 'System'}</td>
//                         <td>${parseFloat(t.opening_bal).toFixed(2)}</td>
//                         <td className={t.credit_bal > 0 ? "text-green" : "text-red"}>
//                             {t.credit_bal > 0 ? `+$${t.credit_bal}` : `-$${t.debit_bal}`}
//                         </td>
//                         <td>${parseFloat(t.closing_bal).toFixed(2)}</td>
//                         <td><Calendar size={14}/> {new Date(t.created_at).toLocaleDateString()}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>
//         </div>
//          <footer className="footer-dark">
//           <div className="container">
//             <p className="text-center mb-0 text-white">
//               Copyright © 2025 Willow Quantum. All rights reserved.
//             </p>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default LowestIncome;

import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { Search, Filter, Download, ChevronLeft, ChevronRight, Users, DollarSign, Award, TrendingUp, Clock, Gift } from 'lucide-react';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import '../../Dashboard Style/WalletTransaction.css';
import { getLowestIncomeBonusApi } from '../../Services/Operations/ProductAPI';

const LowestIncome = ({ title, incomeType }) => {
  const authToken = useSelector((state) => state.user?.token);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [bonuses, setBonuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateFilter, setDateFilter] = useState('all');
  const [totalBonus, setTotalBonus] = useState(0);
  const [totalDistributed, setTotalDistributed] = useState(0);
  const [totalReceived, setTotalReceived] = useState(0);

      const [isMobile, setIsMobile] = useState(false);
  
    // Check screen size on mount and resize
    useEffect(() => {
      const checkMobile = () => {
        const mobile = window.innerWidth < 992;
        setIsMobile(mobile);
  
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(true);
        } else {
          setSidebarOpen(true);
        }
      };
  
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  
  
  
    const closeSidebar = () => {
      if (isMobile) {
        setSidebarOpen(false);
      }
    };

  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  
  // Initialize sidebar functionality
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');
    
    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }
    
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    return () => {
      // Cleanup
    };
  }, [sidebarOpen]);
  
  useEffect(() => {
    // Add custom styles for Lowest Income Bonus page
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      /* Lowest Income Bonus specific styles */
      .bonus-badge {
        background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
        color: white;
        padding: 6px 15px;
        border-radius: 20px;
        font-size: 13px;
        font-weight: 700;
        display: inline-block;
      }
      
      .achiever-card {
        background: rgba(255, 107, 107, 0.1);
        border-radius: 8px;
        padding: 12px;
        border-left: 3px solid #ff6b6b;
      }
      
      .user-count-badge {
        background: rgba(33, 150, 243, 0.2);
        color: #2196f3;
        padding: 3px 10px;
        border-radius: 15px;
        font-size: 11px;
        font-weight: 600;
      }
      
      .amount-value-bonus {
        font-weight: 700;
        font-size: 16px;
        color: #4caf50;
      }
      
      .distribute-amount {
        font-weight: 600;
        font-size: 15px;
        color: #ff9800;
      }
      
      .received-amount {
        font-weight: 700;
        font-size: 16px;
        color: #9c27b0;
      }
      
      /* Table styles */
      .lowest-income-table {
        background: rgba(30, 30, 40, 0.8);
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
      }
      
      .lowest-income-table thead th {
        background: linear-gradient(135deg, rgba(255, 107, 107, 0.2) 0%, rgba(238, 90, 82, 0.2) 100%);
        color: #ffffff !important;
        font-weight: 700;
        text-transform: uppercase;
        font-size: 13px;
        letter-spacing: 0.8px;
        padding: 18px 15px;
        border-bottom: 2px solid rgba(255, 107, 107, 0.4);
      }
      
      .lowest-income-table tbody td {
        padding: 16px 15px;
        vertical-align: middle;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        color: #ffffff !important;
        background: rgba(40, 40, 50, 0.5);
        transition: all 0.3s ease;
      }
      
      .lowest-income-table tbody tr:nth-child(even) td {
        background: rgba(35, 35, 45, 0.5);
      }
      
      .lowest-income-table tbody tr:hover td {
        background: rgba(50, 50, 65, 0.7);
        transform: scale(1.005);
      }
      
      /* SL. NO. styling */
      .sl-no-circle-bonus {
        background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
        color: white;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 800;
        font-size: 14px;
        box-shadow: 0 4px 8px rgba(255, 107, 107, 0.3);
      }
      
      /* Pagination styles */
      .pagination-container-bonus {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        background: rgba(30, 30, 40, 0.8);
        border-radius: 10px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        margin-top: 20px;
      }
      
      .pagination-info-bonus {
        color: #adb5bd;
        font-size: 14px;
        font-weight: 500;
      }
      
      .pagination-buttons-bonus .btn {
        margin: 0 4px;
        min-width: 40px;
        height: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        transition: all 0.3s ease;
      }
      
      .pagination-buttons-bonus .btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      }
      
      /* Summary cards */
      .summary-card-bonus {
        background: linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%);
        border-radius: 12px;
        padding: 25px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
      }
      
      .summary-card-bonus:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 4px;
      }
      
      .summary-card-bonus.total-bonus:before {
        background: linear-gradient(90deg, #4caf50, #8bc34a);
      }
      
      .summary-card-bonus.distributed:before {
        background: linear-gradient(90deg, #ff9800, #ffc107);
      }
      
      .summary-card-bonus.received:before {
        background: linear-gradient(90deg, #9c27b0, #673ab7);
      }
      
      .summary-card-bonus:hover {
        transform: translateY(-8px);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.4);
      }
      
      /* Search box styles */
      .search-box-bonus {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
        padding: 12px 20px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        display: flex;
        align-items: center;
        transition: all 0.3s ease;
      }
      
      .search-box-bonus:focus-within {
        border-color: #ff6b6b;
        box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.2);
      }
      
      .search-box-bonus input {
        background: transparent;
        border: none;
        color: white;
        flex: 1;
        padding: 0 15px;
        outline: none;
        font-size: 14px;
      }
      
      .search-box-bonus input::placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
      
      /* Icon containers */
      .icon-circle-bonus {
        width: 48px;
        height: 48px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        font-size: 22px;
      }
      
      .icon-circle-bonus.total {
        background: linear-gradient(135deg, rgba(76, 175, 80, 0.2), rgba(139, 195, 74, 0.2));
        color: #4caf50;
      }
      
      .icon-circle-bonus.distributed {
        background: linear-gradient(135deg, rgba(255, 152, 0, 0.2), rgba(255, 193, 7, 0.2));
        color: #ff9800;
      }
      
      .icon-circle-bonus.received {
        background: linear-gradient(135deg, rgba(156, 39, 176, 0.2), rgba(103, 58, 183, 0.2));
        color: #9c27b0;
      }
      
      /* Ensure all text is visible */
      .text-white {
        color: #ffffff !important;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      }
      
      .text-muted {
        color: #adb5bd !important;
      }
      
      .text-success { color: #4caf50 !important; }
      .text-warning { color: #ff9800 !important; }
      .text-purple { color: #9c27b0 !important; }
      .text-info { color: #2196f3 !important; }
      .text-danger { color: #ff6b6b !important; }
    `;
    document.head.appendChild(style);
    
    // Fetch data on component mount
    fetchLowestIncomeBonus();

    return () => {
      document.head.removeChild(style);
    };
  }, [currentPage, perPage]);

    useEffect(() => {
        const sidebar = document.querySelector('.sidebar');
        const sidebarBody = document.querySelector('.sidebar-body');
        
        if (sidebar) {
          if (sidebarOpen) {
            sidebar.classList.remove('close');
          } else {
            sidebar.classList.add('close');
          }
        }
        
        if (sidebarBody) {
          sidebarBody.style.height = 'calc(100vh - 70px)';
          sidebarBody.style.overflowY = 'auto';
        }
    
        return () => {};
      }, [sidebarOpen]);
    
      useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
          .sidebar-body {
            height: calc(100vh - 70px);
            overflow-y: auto;
          }
          
          .sidebar-body::-webkit-scrollbar {
            width: 6px;
          }
          
          .sidebar-body::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.05);
            border-radius: 10px;
          }
          
          .sidebar-body::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.2);
            border-radius: 10px;
          }
          
          .sidebar-body::-webkit-scrollbar-thumb:hover {
            background: rgba(255, 255, 255, 0.3);
          }
          
          .sidebar .nav-dropdown {
            list-style: none;
            padding-left: 0;
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.3s ease;
          }
          
          .sidebar .nav-dropdown.show {
            max-height: 500px;
          }
          
          .sidebar .nav-dropdown-item {
            padding-left: 2.5rem;
          }
          
          .nav-item.has-dropdown .nav-link {
            position: relative;
            padding-right: 2.5rem;
          }
          
          .nav-item.has-dropdown .dropdown-icon {
            position: absolute;
            right: 1rem;
            top: 50%;
            transform: translateY(-50%);
            transition: transform 0.3s ease;
          }
          
          .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
            transform: translateY(-50%) rotate(180deg);
          }
          
          .nav-item.has-dropdown .nav-dropdown {
            background: rgba(255, 255, 255, 0.05);
            border-left: 3px solid var(--primary-color, #0d6efd);
            margin-left: 1rem;
            border-radius: 0 0 8px 8px;
          }
          
          .nav-item.has-dropdown .nav-dropdown-item .nav-link {
            padding: 0.75rem 1rem 0.75rem 2rem;
            color: rgba(255, 255, 255, 0.8);
          }
          
          .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
            background: rgba(255, 255, 255, 0.1);
            color: white;
          }
          
          .nav-item.has-dropdown .link-title.nav-item.nav-category {
            font-weight: 600;
            font-size: 0.875rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          
          .sidebar {
            transition: all 0.3s ease;
          }
        `;
        document.head.appendChild(style);
    
        return () => {
          document.head.removeChild(style);
        };
      }, []);
    
  
  const fetchLowestIncomeBonus = async () => {
    try {
      setLoading(true);
      const result = await getLowestIncomeBonusApi(authToken, currentPage, perPage);
      
      if (result.status) {
        setBonuses(result.data);
        setTotalPages(result.pagination.last_page || 1);
        
        // Calculate totals
        const bonusTotal = result.data.reduce((sum, item) => 
          sum + (parseFloat(item.total_amount) || 0), 0);
        const distributedTotal = result.data.reduce((sum, item) => 
          sum + (parseFloat(item.distribute_amount) || 0), 0);
        const receivedTotal = result.data.reduce((sum, item) => 
          sum + (parseFloat(item.received_amount) || 0), 0);
        
        setTotalBonus(bonusTotal);
        setTotalDistributed(distributedTotal);
        setTotalReceived(receivedTotal);
        
        // toast.success(result.message || 'Lowest income bonus loaded successfully');
      } else {
        toast.error(result.message || 'Failed to load lowest income bonus');
      }
    } catch (error) {
      console.error('Error fetching lowest income bonus:', error);
      toast.error('Network error. Please check your connection.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleSearch = (e) => {
    e.preventDefault();
  };
  
  const handleDateFilterChange = (filter) => {
    setDateFilter(filter);
    setCurrentPage(1);
  };
  
  const filteredBonuses = useMemo(() => {
    let filtered = [...bonuses];
    
    // Apply search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(bonus => 
        bonus.transaction_id?.toString().toLowerCase().includes(query) ||
        bonus.user_id?.toString().toLowerCase().includes(query) ||
        bonus.total_amount?.toString().includes(query) ||
        bonus.distribute_amount?.toString().includes(query) ||
        bonus.received_amount?.toString().includes(query)
      );
    }
    
    // Apply date filter
    if (dateFilter !== 'all') {
      const now = new Date();
      filtered = filtered.filter(bonus => {
        const bonusDate = new Date(bonus.created_at);
        
        switch (dateFilter) {
          case 'today':
            return bonusDate.toDateString() === now.toDateString();
          case 'week': {
            const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            return bonusDate >= oneWeekAgo;
          }
          case 'month': {
            const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
            return bonusDate >= oneMonthAgo;
          }
          case 'year': {
            const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
            return bonusDate >= oneYearAgo;
          }
          default:
            return true;
        }
      });
    }
    
    return filtered;
  }, [bonuses, searchQuery, dateFilter]);
  
  const handleDownload = () => {
    if (filteredBonuses.length === 0) {
      toast.warning('No data to export');
      return;
    }
    
    const exportData = filteredBonuses.map((bonus, index) => ({
      'ID': bonus.id,
      'User ID': bonus.user_id,
      'Transaction ID': bonus.transaction_id,
      'Total Achievers': bonus.total_achiever,
      'Total Users': bonus.total_users,
      'Total Amount': `$${parseFloat(bonus.total_amount || 0).toFixed(2)}`,
      'Distribute Amount': `$${parseFloat(bonus.distribute_amount || 0).toFixed(2)}`,
      'Received Amount': `$${parseFloat(bonus.received_amount || 0).toFixed(2)}`,
      'Created At': bonus.created_at,
      'Updated At': bonus.updated_at || 'N/A'
    }));
    
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Lowest Income Bonus');
    XLSX.writeFile(wb, `Lowest_Income_Bonus_${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.success('Lowest income bonus report exported successfully!');
  };
  
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };
  
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };
  
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  
  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };
  
  // Calculate percentage
  const calculatePercentage = (part, total) => {
    if (!total || total === 0) return 0;
    return ((part / total) * 100).toFixed(1);
  };

  return (
    <div className="main-wrapper dark-theme">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Sidebar
                   isOpen={!sidebarOpen}
                   onClose={closeSidebar}
                 />
       
                 {/* Mobile backdrop */}
                 {isMobile && sidebarOpen && (
                   <div
                     className="sidebar-backdrop"
                     onClick={closeSidebar}
                   />
                 )}
      </nav>

      <div className="page-wrapper">
        <Navbar toggleSidebar={toggleSidebar}  isSidebarOpen={sidebarOpen}
            isMobile={isMobile}/>

        
        <div className="page-content p-4">
          {/* Page Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="text-white fw-bold mb-1">{title}</h3>
              <p className="text-muted mb-0">Track your lowest income bonus distributions and earnings</p>
            </div>
            <div>
              <span className="badge bg-gradient-bonus px-3 py-2" style={{ background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)' }}>
                <Award size={16} className="me-2" />
                Bonus System
              </span>
            </div>
          </div>
          
          {/* Summary Cards */}
          <div className="row mb-4">
            <div className="col-md-4">
              <div className="summary-card-bonus total-bonus">
                <div className="d-flex align-items-center">
                  <div className="icon-circle-bonus total">
                    <DollarSign size={24} />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Bonus Pool</h6>
                    <h3 className="text-white mb-0 text-success">${totalBonus.toFixed(2)}</h3>
                    <small className="text-muted">Available for distribution</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="summary-card-bonus distributed">
                <div className="d-flex align-items-center">
                  <div className="icon-circle-bonus distributed">
                    <TrendingUp size={24} />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Distributed</h6>
                    <h3 className="text-white mb-0 text-warning">${totalDistributed.toFixed(2)}</h3>
                    <small className="text-muted">
                      {calculatePercentage(totalDistributed, totalBonus)}% of pool
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="summary-card-bonus received">
                <div className="d-flex align-items-center">
                  <div className="icon-circle-bonus received">
                    <Gift size={24} />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">You Received</h6>
                    <h3 className="text-white mb-0 text-purple">${totalReceived.toFixed(2)}</h3>
                    <small className="text-muted">
                      {calculatePercentage(totalReceived, totalDistributed)}% of distributed
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Search and Filter Section */}
          <div className="row mb-4">
            <div className="col-md-8">
              <div className="d-flex gap-3">
                <form onSubmit={handleSearch} className="flex-grow-1">
                  <div className="search-box-bonus">
                    <Search size={18} className="text-muted me-2" />
                    <input
                      type="text"
                      placeholder="Search by transaction ID, amount, or user ID..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </form>
                <div className="dropdown">
                  <button
                    className="btn btn-outline-light dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <Filter size={16} className="me-2" />
                    {dateFilter === 'all' ? 'All Time' : dateFilter.charAt(0).toUpperCase() + dateFilter.slice(1)}
                  </button>
                  <div className="dropdown-menu">
                    <button 
                      className={`dropdown-item ${dateFilter === 'today' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('today')}
                    >
                      Today
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'week' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('week')}
                    >
                      This Week
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'month' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('month')}
                    >
                      This Month
                    </button>
                    <button 
                      className={`dropdown-item ${dateFilter === 'year' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('year')}
                    >
                      This Year
                    </button>
                    <div className="dropdown-divider"></div>
                    <button 
                      className={`dropdown-item ${dateFilter === 'all' ? 'active' : ''}`}
                      onClick={() => handleDateFilterChange('all')}
                    >
                      All Time
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex justify-content-end gap-2">
                <button 
                  className="btn btn-outline-light"
                  onClick={handleDownload}
                  disabled={filteredBonuses.length === 0}
                >
                  <Download size={16} className="me-2" />
                  Export ({filteredBonuses.length})
                </button>
                <div className="dropdown">
                  <button
                    className="btn btn-outline-light dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    {perPage} per page
                  </button>
                  <div className="dropdown-menu">
                    {[10, 15, 25, 50, 100].map((num) => (
                      <button
                        key={num}
                        className={`dropdown-item ${perPage === num ? 'active' : ''}`}
                        onClick={() => {
                          setPerPage(num);
                          setCurrentPage(1);
                          toast.info(`Displaying ${num} records per page`);
                        }}
                      >
                        {num} per page
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Table Section */}
          <div className="lowest-income-table">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-danger" style={{ width: '3rem', height: '3rem' }} role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 text-white">Loading lowest income bonus data...</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th>SL. NO.</th>
                   
                      <th>USER STATS</th>
                      <th>TOTAL AMOUNT</th>
                      <th>DISTRIBUTE AMOUNT</th>
                      <th>RECEIVED AMOUNT</th>
                      <th>TIMESTAMP</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredBonuses.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center py-5">
                          <div className="text-muted">
                            <Award size={48} className="mb-3 opacity-50 text-danger" />
                            <h5 className="text-white">No lowest income bonus found</h5>
                            <p className="text-muted mb-0">Qualify for lowest income bonus to see earnings</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      filteredBonuses.map((bonus, index) => (
                        <tr key={bonus.id} className="border-bottom border-dark">
                          {/* SL. NO. - Using ID field */}
                          <td className="align-middle">
                            <div className="d-flex align-items-center">
                              <div className="sl-no-circle-bonus me-3">
                                {bonus.id}
                              </div>
                              {/* <span className="text-white fw-bold fs-6">{bonus.id}</span> */}
                            </div>
                          </td>
                          
                        
                          
                          {/* USER STATS */}
                          <td className="align-middle">
                            <div className="achiever-card">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="user-count-badge">
                                  <Users size={14} className="me-1" />
                                  Achievers: {bonus.total_achiever}
                                </span>
                                <span className="user-count-badge" style={{ background: 'rgba(76, 175, 80, 0.2)', color: '#4caf50' }}>
                                  Total Users: {bonus.total_users}
                                </span>
                              </div>
                              {/* <div className="text-center mt-3">
                                <div className="text-white small">Achiever Ratio</div>
                                <div className="text-warning fw-bold fs-5">
                                  {calculatePercentage(bonus.total_achiever, bonus.total_users)}%
                                </div>
                              </div> */}
                            </div>
                          </td>
                          
                          {/* TOTAL AMOUNT */}
                          <td className="align-middle">
                            <div className="d-flex align-items-center">
                              {/* <div className="bg-success bg-opacity-10 rounded-3 d-flex align-items-center justify-content-center me-3" 
                                   style={{ width: '50px', height: '50px' }}>
                                <DollarSign size={22} className="text-success" />
                              </div> */}
                              <div>
                                <div className="text-white fw-bold fs-5">${parseFloat(bonus.total_amount || 0).toFixed(2)}</div>
                                {/* <div className="text-muted small">Total Pool</div> */}
                              </div>
                            </div>
                          </td>
                          
                          {/* DISTRIBUTE AMOUNT */}
                          <td className="align-middle">
                            <div className="bg-warning bg-opacity-10 p-3 rounded-3">
                              <div className="text-warning fw-bold fs-5 text-center">${parseFloat(bonus.distribute_amount || 0).toFixed(2)}</div>
                              {/* <div className="text-muted small text-center mt-1">Distributed</div> */}
                              {/* <div className="text-info small text-center mt-1">
                                {calculatePercentage(bonus.distribute_amount, bonus.total_amount)}% of pool
                              </div> */}
                            </div>
                          </td>
                          
                          {/* RECEIVED AMOUNT */}
                          <td className="align-middle">
                            <div className="bg-purple bg-opacity-10 p-3 rounded-3">
                              <div className="text-purple fw-bold fs-5 text-center">${parseFloat(bonus.received_amount || 0).toFixed(2)}</div>
                              {/* <div className="text-muted small text-center mt-1">You Received</div> */}
                              {/* <div className="text-success small text-center mt-1">
                                {calculatePercentage(bonus.received_amount, bonus.distribute_amount)}% of distributed
                              </div> */}
                            </div>
                          </td>
                          
                          {/* TIMESTAMP */}
                          <td className="align-middle">
                            <div className="bg-dark border border-secondary border-opacity-25 p-3 rounded-3">
                              {/* <div className="d-flex align-items-center mb-2">
                                <Clock size={16} className="me-2 text-primary" />
                                <span className="text-white small fw-semibold">Created</span>
                              </div> */}
                              <div className="text-white small">{formatDate(bonus.created_at)}</div>
                              {bonus.updated_at && (
                                <>
                                  <div className="d-flex align-items-center mt-2 mb-1">
                                    <Clock size={14} className="me-2 text-info" />
                                    <span className="text-muted small fw-semibold">Updated</span>
                                  </div>
                                  <div className="text-muted small">{formatDate(bonus.updated_at)}</div>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          
          {/* Pagination */}
          {!loading && filteredBonuses.length > 0 && (
            <div className="pagination-container-bonus">
              <div className="pagination-info-bonus">
                Showing {(currentPage - 1) * perPage + 1} to {Math.min(currentPage * perPage, filteredBonuses.length)} of {filteredBonuses.length} entries
              </div>
              <div className="pagination-buttons-bonus">
                <button
                  className="btn btn-outline-light"
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                >
                  <ChevronLeft size={16} /> Prev
                </button>
                
                <div className="page-numbers d-inline-block mx-2">
                  {(() => {
                    const pageNumbers = [];
                    const maxPagesToShow = 5;
                    
                    if (totalPages <= maxPagesToShow) {
                      for (let i = 1; i <= totalPages; i++) {
                        pageNumbers.push(i);
                      }
                    } else {
                      if (currentPage <= 3) {
                        for (let i = 1; i <= 5; i++) {
                          pageNumbers.push(i);
                        }
                      } else if (currentPage >= totalPages - 2) {
                        for (let i = totalPages - 4; i <= totalPages; i++) {
                          pageNumbers.push(i);
                        }
                      } else {
                        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
                          pageNumbers.push(i);
                        }
                      }
                    }
                    
                    return pageNumbers.map((pageNum) => (
                      <button
                        key={pageNum}
                        className={`btn ${currentPage === pageNum ? 'btn-danger' : 'btn-outline-light'}`}
                        onClick={() => handlePageClick(pageNum)}
                      >
                        {pageNum}
                      </button>
                    ));
                  })()}
                  
                  {totalPages > 5 && currentPage < totalPages - 2 && (
                    <>
                      <span className="mx-2 text-muted">...</span>
                      <button
                        className="btn btn-outline-light"
                        onClick={() => handlePageClick(totalPages)}
                      >
                        {totalPages}
                      </button>
                    </>
                  )}
                </div>
                
                <button
                  className="btn btn-outline-light"
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next <ChevronRight size={16} />
                </button>
              </div>
            </div>
          )}
        </div>
        
        {/* Footer */}
        <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
          <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default LowestIncome;